module.exports = __webpack_public_path__ + "public/img/rubbish3.bba57de5.png";